import { defineMessages } from 'react-intl';

import {
  CommunicationContextType,
  ComposeContextRowType,
  ComposeContextValueKind,
  SportTermLookup,
  SportTerminology
} from '../../../lib/types';

export const scope = 'app.components.Communication.ContextSelector';

export const getMessages = (termLookup: SportTermLookup) =>
  defineMessages({
    assessmentChip: { id: `${scope}.assessmentChip`, defaultMessage: 'Assessment: {name}' },
    addContext: { id: `${scope}.addContext`, defaultMessage: 'Add context' },
    typeAgeGroup: { id: `${scope}.typeAgeGroup`, defaultMessage: 'Age group' },
    typeSession: {
      id: `${scope}.typeSession`,
      defaultMessage: termLookup[SportTerminology.SESSION]
    },
    typeLevel: { id: `${scope}.typeLevel`, defaultMessage: 'Level' },
    typeTeam: { id: `${scope}.typeTeam`, defaultMessage: 'Team' },
    typePlayer: {
      id: `${scope}.typePlayer`,
      defaultMessage: termLookup[SportTerminology.ATHLETE]
    },
    noLongerAvailable: { id: `${scope}.noLongerAvailable`, defaultMessage: 'No longer available' },
    playersNoLongerFit: {
      id: `${scope}.playersNoLongerFit`,
      defaultMessage: '{count} selected {playerWord} no longer {verbWord} the filter criteria'
    }
  });

// Menu label per row kind — sport words ("Ice Time", "Player") arrive through
// the company term lookup; identifiers stay sport-agnostic.
export const getContextTypeMessages = (
  termLookup: SportTermLookup
): Record<ComposeContextRowType, { id: string; defaultMessage: string }> => {
  const messages = getMessages(termLookup);
  return {
    [CommunicationContextType.AGE_GROUP]: messages.typeAgeGroup,
    [CommunicationContextType.ASSESSMENT_SESSION]: messages.typeSession,
    [ComposeContextValueKind.LEVEL]: messages.typeLevel,
    [ComposeContextValueKind.TEAM]: messages.typeTeam,
    [CommunicationContextType.PLAYER_ASSESSMENT]: messages.typePlayer
  };
};
